import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const sections = [
  {
    title: "1. Acceptance of Terms",
    body: "By accessing or using Max Employee, you agree to these Terms of Service and any additional guidelines we publish for specific products or features.",
  },
  {
    title: "2. Use of the Service",
    body: "You may use the service only for lawful business purposes. You are responsible for the accuracy of information you provide and for securing your account credentials.",
  },
  {
    title: "3. Subscriptions and Payments",
    body: "Some features require a paid subscription. Fees, trial periods, and cancellation terms are shown at checkout or on the pricing page.",
  },
  {
    title: "4. Prohibited Activities",
    body: "You may not misuse the platform, attempt unauthorized access, interfere with service operation, or use the service to violate applicable laws.",
  },
  {
    title: "5. Intellectual Property",
    body: "Max Employee, its branding, software, and content are protected by intellectual property laws. You retain rights to content you submit, subject to the license required to operate the service.",
  },
  {
    title: "6. Termination",
    body: "We may suspend or terminate access if we reasonably believe the service is being misused or if required by law.",
  },
  {
    title: "7. Contact",
    body: "Questions about these Terms can be sent to sales@maxemployee.com.",
  },
];

export default function Terms() {
  return (
    <>
      <SEOHead
        title="Terms of Service | Max Employee"
        description="Read the Max Employee Terms of Service, including service use, subscriptions, prohibited activities, and termination terms."
        url="/terms"
      />
      <Header />
      <main id="main-content" className="min-h-screen bg-[#09090B] text-white">
        <section className="border-b border-zinc-900 bg-gradient-to-b from-amber-500/5 to-transparent">
          <div className="max-w-5xl mx-auto px-6 lg:px-12 py-20 lg:py-24">
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-amber-500 mb-4">// LEGAL</p>
            <h1 className="font-display text-4xl lg:text-6xl uppercase tracking-tight leading-tight mb-6">
              Terms of Service
            </h1>
            <p className="text-zinc-400 max-w-2xl text-lg leading-relaxed">
              These terms describe how Max Employee may be used, what users can expect from the service,
              and the responsibilities that apply when using our products.
            </p>
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-6 lg:px-12 py-16">
          <div className="space-y-6">
            {sections.map((section) => (
              <article key={section.title} className="border border-zinc-900 rounded-2xl bg-zinc-950/60 p-6 lg:p-8">
                <h2 className="font-display text-2xl uppercase mb-3 text-amber-500">{section.title}</h2>
                <p className="text-zinc-300 leading-relaxed">{section.body}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
